import React from 'react';

function HeaderAccount() {
  return (
    <p>MerchantName</p>
  )
};

export default HeaderAccount;

